<template>
  <auth-layout pageClass="support-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-6 col-md-8 col-sm-10">
        <card>
          <div class="card-header" slot="header">
            <h3
              class="card-title text-center"
              style="color: #d9d9d9; font-weight: bold"
            >
              Support
            </h3>
          </div>
          <div class="card-body text-center">
            <p class="support-text">
              For any support questions or assistance, please contact us at:
            </p>
            <a
              href="mailto:admin@alliessupportedemployment.com"
              class="support-email"
            >
              admin@alliessupportedemployment.com
            </a>
          </div>
        </card>
      </div>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from "./AuthLayout.vue";

export default {
  components: {
    AuthLayout,
  },
};
</script>

<style>
.card-header {
  background: none !important;
  height: 60px;
  font-family: "Playfair Display", serif;
}

.support-page .card {
  max-width: 500px !important;
  margin: 0 auto;
}
</style>

<style scoped>
.card-title {
  font-family: "Playfair Display", serif;
}

.card-body {
  padding: 30px 20px;
}

.support-text {
  color: #d9d9d9;
  font-family: "Nimbus Sans Light", sans-serif;
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.support-email {
  color: #66b3ff;
  font-family: "Nimbus Sans Light", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s ease;
  word-break: break-all;
}

.support-email:hover {
  color: #99ccff;
  text-decoration: underline;
}

/* Mobile-specific adjustments */
@media (max-width: 576px) {
  .card {
    margin: 0 10px !important;
  }

  .support-email {
    font-size: 16px;
  }
}
</style>
